import { render } from "./Magnify.vue?vue&type=template&id=194dfb2a"
import script from "./Magnify.vue?vue&type=script&lang=js"
export * from "./Magnify.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__